module.exports = __webpack_public_path__ + "media/images/approved-a3df637c94be1cd894d3a7456370e9f6.png";